/** Local-only counters for Studio UX signals (no network; opt-in pattern for privacy). */

const STORAGE_KEY = 'studio_v2_friendliness_signals_v1';

export function recordFriendlinessEvent(eventId) {
  if (!eventId || typeof window === 'undefined') return;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const o = raw ? JSON.parse(raw) : {};
    o[eventId] = (o[eventId] || 0) + 1;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(o));
  } catch {
    /* ignore quota / private mode */
  }
}
